import { useCallback } from 'react'

export const useSubmit = onHandleSubmit => {
    return useCallback(async data => onHandleSubmit(data), [onHandleSubmit])
}
